import React, { useState } from "react";
import "./FAQ.css";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { faqData } from "./faqData";

const FAQ = () => {
  const [openAnswers, setOpenAnswers] = useState([]);

  const handleFAQ = (id) => {
    // Check if the id is already open; if it is, remove it, else add it
    setOpenAnswers((prevOpenAnswers) =>
      prevOpenAnswers.includes(id)
        ? prevOpenAnswers.filter((answerId) => answerId !== id)
        : [...prevOpenAnswers, id]
    );
  };

  return (
    <>
      <div style={{ backgroundColor: "" }} id="faq_container">
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 700,
            fontFamily: "'Archivo', sans-serif",
          }}
          className="archivo py-2 fw-bold"
        >
          FAQs for SBI Personal Loan EMI Calculator
        </Typography>
        <div
          style={{ border: "1px solid #8A8A8A" }}
          className="w-100 border-start border-bottom-0 border-start-0 border-end-0 "
        >
          {faqData &&
            faqData.map((item) => (
              <div
                key={item.id}
                style={{ border: "2px solid #8A8A8A" }}
                className="faq_container d-flex border-top-0 border-1 border-start-0 border-end-0"
              >
                <div className="w-100">
                  <div
                    className="question_box py-3 d-flex justify-content-between w-100 "
                    onClick={() => handleFAQ(item.id)}
                  >
                    <Typography
                      sx={{
                        width: "100%",
                        fontSize: 16,
                        fontWeight: 700,
                        lineHeight: "24px",
                        fontFamily: "'Archivo',sans-serif",
                      }}
                    >
                      {item.question}
                    </Typography>
                    <Typography className="w-25 text-end">
                      <FontAwesomeIcon
                        icon={
                          openAnswers.includes(item.id)
                            ? faChevronUp
                            : faChevronDown
                        }
                      />
                    </Typography>
                  </div>
                  {openAnswers.includes(item.id) && (
                    <div className="answer_box mt-3">
                      <Typography
                        sx={{
                          fontSize: 16,
                          fontWeight: 500,
                          lineHeight: "24px",
                          fontFamily: "'Archivo',sans-serif",
                        }}
                      >
                        {item.answer}
                      </Typography>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default FAQ;
